import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SoldOutButtonProps {
    className?: string
}

const SoldOutButton: FC<SoldOutButtonProps> = ({ className }): ReactNode => (
    <button
        type='button'
        disabled
        title='This edition is sold out'
        className={cn(
            'inline-flex h-9 cursor-not-allowed items-center rounded-lg bg-gradient-to-b from-[#f4f4f5] to-[#d6d6d9] px-3.5 text-[14px] font-medium text-[#3d3d42] line-through decoration-[#3d3d42]/80 shadow-[inset_0_1px_0_rgb(255_255_255),0_2px_10px_rgb(0_0_0/0.45)]',
            className
        )}
    >
        Sold out
    </button>
)

export default SoldOutButton
